<template>
  <a-date-picker
    v-model:value="dateValue"
    :format="format"
    :disabled="disabled"
    :dropdownClassName="dropdownClassName"
    :getPopupContainer="triggerNode => triggerNode.parentNode.parentNode"
    @change="handleChange"
  />
</template>
<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import dayjs from 'dayjs'

const props = defineProps({
  data: {
    required: true,
    type: Object,
    default: {}
  },
  disabled: {
    required: true,
    type: Boolean,
    default: false
  },
  dropdownClassName: {
    required: true,
    type: String,
    default: ''
  }
})
const emit = defineEmits(['update:value', 'change'])
const dateValue = ref<any | undefined>(undefined)

const format = computed(() => {
  if (props.data.dateType === '2') return 'YYYY.MM.DD'
  if (props.data.dateType === '3') return 'DD/MMM/YYYY'
  return 'MMM DD,YYYY'
})

// 暂定入参
const handleChange = () => {
  emit('change', dateValue.value ? dayjs(dateValue.value).valueOf() : undefined)
}

onMounted(async () => {
  if (props.data.fieldValue) {
    dateValue.value = dayjs(Number(props.data.fieldValue))
  }
})
</script>
